import { CreateComission } from "./CreateComission";
import { CreateGlamboxComission } from "./CreateGlamboxComission";
import React from 'react';
import { Col } from "components/grid/Col";
import { Row } from "components/grid/Row";
import { Container } from "components/grid/Container";

export class CreateComissions extends React.Component {
  constructor(props) {
    super(props);


  }

  render ()  {
    return(
      <div className={"p-2 p-lg-5"}>
        <h1>Criar Comissões</h1>
        <Container fluid>
            <Row>
              <Col xs={12} lg={6}>
                <CreateGlamboxComission />
                <CreateComission />
              </Col>
          </Row>       
        </Container>
      </div>
    );
  }

}